/**
* Component FooterComponent
*
* Display informations about the website (for example contact person, contact number, address, ... )
*
* Intern component : 
* -  MDBFooter, MDBIcon, MDBRow, MDBCol, MDBContainer : component to manage 


<template>
   <MDBFooter :text="['center', 'lg-start', 'muted']" class="footer_container" data-aos="fade" data-aos-duration="1000" data-aos-easing="ease-in-out">
    <section
      class="d-flex justify-content-center justify-content-lg-between  border-bottom"
    ></section>
    <!-- Section: Links  -->
    <section>
      <MDBContainer class="text-center text-md-start mt-5">
        <!-- Grid row -->
        <MDBRow class="mt-3">
          <!-- Grid column -->
          <MDBCol md="3" lg="4" xl="3" class="mx-auto mb-4">
            <!-- Content -->
            <h6 class="text-uppercase fw-bold mb-4">
              <i ></i>{{$t("footer.title")}}
            </h6>
            <p>
             {{$t("footer.address1")}} <br/> {{$t("footer.address2")}}
            </p>
            <p>
             "{{$t("footer.citation")}}"
            </p>
          </MDBCol>
        

          <!-- Grid column -->
          <MDBCol md="2" lg="2" xl="2" class="mx-auto mb-4">
            <!-- Links -->
            <h6 class="text-uppercase fw-bold mb-4"> {{$t("footer.links")}}</h6>
            <p>
              <a href="/diponible-merrien" class="footer-link">  {{$t("footer.availability")}} </a>
            </p>
            <p>
              <a href="/infos-pratiques" class="footer-link">{{$t("footer.practical")}} </a >
            </p>
            <p>
              <a href="/a-propos" class="footer-link">{{$t("footer.about")}} </a>
            </p>
          </MDBCol>
          <!-- Grid column -->

          <!-- Grid column -->
          <MDBCol md="4" lg="3" xl="3" class="mx-auto mb-md-0 mb-4">
            <!-- Links -->
            <h6 class="text-uppercase fw-bold mb-4">{{$t("footer.contact")}} </h6>
            <p>
              <i class="fas fa-envelope me-3 link-secondary"></i>
              raymonde.tapparel@gmail.com
            </p>
            <p>
              <MDBIcon icon="phone" class="me-3 link-secondary" />
              +41 78 804 32 41
            </p>
            
          </MDBCol>
          <!-- Grid column -->
        </MDBRow>
        <!-- Grid row -->
      </MDBContainer>
    </section>
    <!-- Section: Links  -->

    <!-- Copyright -->
    <div
      class="text-center p-4"
      style="background-color: rgba(0, 0, 0, 0.05)"
    >
      © 2025 Copyright:
      <a class="text-reset fw-bold" href="https://www.webinblocks.ch/"
        >Made with ✨ by WebInBlocks</a
      >
    </div>
    <!-- Copyright -->
  </MDBFooter>
  <!-- Footer -->
</template>
 
 <script>
  import { MDBFooter, MDBIcon, MDBRow, MDBCol, MDBContainer } from "mdb-vue-ui-kit";

 export default {
   name: 'FooterComponent',
   components: {
      MDBFooter,
      MDBIcon,
      MDBRow,
      MDBCol,
      MDBContainer
    }
}
 </script>
 

 <style lang="scss">
 @import "../assets/styles/_variables.scss";

 .footer_container{
background: #f8f9fa;
  text-align: center;
  margin-top: 1em;

   a.footer-link {
    text-decoration: none;
    display: inline-block;
    color: #757575;
    margin: 0.25rem 0;

    &:hover {
      color: $third-color;
      text-decoration: underline;
    }
  }
  }

/* Responsive Footer */
@media (max-width: 768px) {
  .footer_container {
    text-align: center;

    .mx-auto {
      margin-left: auto !important;
      margin-right: auto !important;
    }
  }
}

 </style>